// Use userTimezone if it exists, otherwise use the publisher's timezone
export function getTimezone(userTimezone: string, publisherTimezone: string): string {
  let timezone = userTimezone;
  if (userTimezone === '' || userTimezone === null) {
    timezone = publisherTimezone;
  }
  return timezone;
}
